<template>
    <div>
        <div class="soli-grey pa-3" v-if="!teachers.length && !loading">
            Sorry, no teachers are available for this selection
        </div>
        <v-select
            v-if="!buttons && !autocomplete"
            :items="teacher ? [teacher] : teachers"
            :value="value"
            v-on:input="$emit('input', $event)"
            item-text="name"
            item-value="id"
            label="Teacher"
            :return-object="returnObject"
            :prepend-inner-icon="hideIcon ? null : 'people'"
            outlined
            dense
            :loading="loading"
            :hideDetails="hideDetails"
            :clearable="clearable"
            :rules="rules"
            no-data-text="No teachers available"
            @click:clear="$emit('clear')"
        ></v-select>
        <v-autocomplete
            v-if="autocomplete && !buttons"
            outlined
            return-object
            dense
            :loading="loading"
            :value="value"
            :items="teacher ? [teacher] : teachers"
            :hideDetails="hideDetails"
            :prepend-inner-icon="hideIcon ? null : 'people'"
            :menu-props="{
                closeOnContentClick: true,
            }"
            :clearable="clearable"
            :rules="rules"
            :return-object="returnObject"
            item-value="id"
            item-text="name"
            label="Teacher"
            no-data-text="No teachers available"
            class="soli-blue-text"
            @input="$emit('input', $event)"
            @keydown.enter.prevent
            @click:clear="$emit('clear')"
        />
        <v-list v-if="buttons && !autocomplete">
            <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="list-item, list-item, list-item"
                v-if="loading"
            ></v-skeleton-loader
            ><v-list-item v-for="teacher in getTeachers" :key="teacher.id">
                <SoliTeacher
                    :teacher="teacher"
                    @input="$emit('input', $event)"
                ></SoliTeacher></v-list-item
        ></v-list>
    </div>
</template>

<script>
export default {
    props: {
        value: {},
        buttons: {
            type: Boolean,
            default: false,
        },
        instrument: {},
        type: {},
        checkTime: {},
        checkTeacherConflicts: {},
        addMinutes: {},
        assignment: {},
        filterTeacher: {},
        filterLocation: {
            type: Number,
            default: null,
        },
        hideDetails: {},
        hideIcon: {},
        clearable: {},
        teacher: {},
        rules: {},
        all: {
            type: Boolean,
            default: false,
        },
        inStudio: {
            type: Boolean,
            default: false,
        },
        returnObject: {
            type: Boolean,
            default: true,
        },
        autocomplete: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {
            teachers: [],
            loading: false,
            tags: [
                "#KidFocused",
                "#CommunityManager",
                "#ocalHealth",
                "#Academia",
            ],
        };
    },
    watch: {
        filterLocation(oldLocation, newLocation) {
            if (oldLocation !== newLocation) {
                this.getApiTeachers();
            }
        },
    },
    computed: {
        getTeachers() {
            return this.instrument
                ? this.teachers.filter(
                      (teacher) =>
                          teacher.instruments
                              .map((i) => i.id)
                              .includes(this.instrument.id) &&
                          teacher.id !== this.filterTeacher
                  )
                : this.checkTime
                ? this.checkConflicts()
                : this.teachers;
        },
    },
    methods: {
        checkConflicts() {
            let start = new Date(this.checkTime[0] + " " + this.checkTime[1]);
            let end = this.addMinutes(start, this.checkTime[2].value);
            let lessons = this.checkTeacherConflicts(start, end);
            let lessonMap = lessons.map((l) => l.teacher.id);
            let availTeachers = this.teachers.filter(
                (teacher) =>
                    !lessonMap.includes(teacher.id) &&
                    teacher.id !== this.filterTeacher
            );
            return availTeachers;
        },
        getApiTeachers() {
            this.loading = true;
            axios
                .get("/api/users/teachers", {
                    params: {
                        filterLocation: this.filterLocation,
                        instrument_id: this.instrument
                            ? this.instrument.id
                            : null,
                        type: this.type,
                        all: Number(this.all),
                        inStudio: Number(this.inStudio),
                    },
                })
                .then((resp) => {
                    let response = resp.data.filter(
                        (e) => e.id !== this.filterTeacher
                    );
                    this.teachers = this.teacher
                        ? response.filter((e) => e.id == this.teacher.id)
                        : response;
                    this.$emit("teachersLoaded");
                    this.loading = false;
                })
                .catch((error) => {
                    this.$emit("error", error);
                });
        },
    },
    mounted() {
        this.getApiTeachers();
    },
};
</script>

<style></style>
